<div class="container my-5">
  <div class="row align-items-center mb-4">
    <h2 class="text-left h3-tipografia-govco mb-0">
      {{ 'interoperabilidad.titulo' | translate }}
    </h2>
  </div>
  <div id="entidades" class="d-flex flex-column gap-3">
    <div class="card-container" *ngFor="let entidad of entidades">
      <div class="d-flex align-items-center">
        <p class="text2-govco mb-0">
          {{ entidad.Entidad }}<br />
          <strong>{{ entidad.nombreCompletoTramite }}</strong><br />
          {{ 'interoperabilidad.fecha_ultimo_corte' | translate }}:
          {{ entidad.fechaUltimoCorte !== undefined ? entidad.fechaUltimoCorte : ('interoperabilidad.sin-informacion' | translate) }}
        </p>
      </div>
      <div class="switch-container">
        <div class="switch-content">
          <button
            [class.active]="entidad.selectedOption === 'manual'"
            (click)="selectOption(entidad, 'manual')"
            class="switch-button"
            aria-label="Seleccionar manual">
            {{ 'interoperabilidad.manual' | translate }}
          </button>
          <button
            [class.active]="entidad.selectedOption === 'interoperabilidad'"
            (click)="selectOption(entidad, 'interoperabilidad')"
            class="switch-button"
            aria-label="Seleccionar interoperabilidad">
            {{ 'interoperabilidad.interoperabilidad' | translate }}
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
